"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "saviano": {
    "6ad514f3": [{
      "hkey": "bb12cfec",
      "slug": "saviano",
      "name": "Saviano",
      "primary": true,
      "skipSearch": false
    }],
    "cerreto": [{
      "hkey": "bb12cfec",
      "slug": "saviano",
      "name": "Saviano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "15217472": [{
      "hkey": "bb12cfec",
      "slug": "saviano",
      "name": "Saviano",
      "primary": true,
      "skipSearch": false
    }],
    "fressuriello": [{
      "hkey": "bb12cfec",
      "slug": "saviano",
      "name": "Saviano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "28ae94c2": [{
      "hkey": "bb12cfec",
      "slug": "saviano",
      "name": "Saviano",
      "primary": true,
      "skipSearch": false
    }],
    "sant-erasmo": [{
      "hkey": "bb12cfec",
      "slug": "saviano",
      "name": "Saviano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ff85f405": [{
      "hkey": "bb12cfec",
      "slug": "saviano",
      "name": "Saviano",
      "primary": true,
      "skipSearch": false
    }],
    "sirico": [{
      "hkey": "bb12cfec",
      "slug": "saviano",
      "name": "Saviano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "43e20636": [{
      "hkey": "bb12cfec",
      "slug": "saviano",
      "name": "Saviano",
      "primary": true,
      "skipSearch": false
    }],
    "tommasoni": [{
      "hkey": "bb12cfec",
      "slug": "saviano",
      "name": "Saviano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;